import React from "react";
import "./ShoeDisplay.css";
import { Socks } from "../../Assests/Assests";
const ShoeDisplay = () => {
  return (
    <div className="shoe-display">
      <div className="image-section">
        <img src={Socks} alt="Air Force 1 Little Kids" />
      </div>
      <div className="details-section">
        <h2>LOVE YOU FOREVER</h2>
        <h3>AIR FORCE 1 - LITTLE KIDS</h3>
        <p>
          PREMIUM LEATHER UPPER. REDESIGNED PERFORATED TOE PANEL. MOLDED
          TRANSLUCENT OUTSOLE WITH MINIATURE HEARTS. TRANSLUCENT TOOLING.
          SYNTHETIC LEATHER LINING. NORTH STARS EMBROIDERED ON LEFT BACK HEEL
          TAB. PLASTIC ALPHABET & NUMBER BEADS INCLUDED.
        </p>
        <p>U.S. SIZING - SEE SIZE CHART FOR CONVERSION.</p>
        <div className="size-guide">SIZE GUIDE</div>
        <div className="sizes">
          {["1Y", "1.5Y", "2Y", "2.5Y", "3Y"].map((size) => (
            <button key={size} className="size-button">
              {size}
            </button>
          ))}
        </div>
        <div className="price-section">
          <button className="select-size-button">SELECT SIZE - $130.00</button>
          <p>OR 4 INTEREST-FREE PAYMENTS OF $32.50 WITH AFTERPAY</p>
        </div>
      </div>
    </div>
  );
};

export default ShoeDisplay;
